module.exports = "closed-lock"